import React from 'react';
import { TrialHero } from '../components/trial/TrialHero';
import { TrialDetails } from '../components/trial/TrialDetails';
import { TrialForm } from '../components/trial/TrialForm';
export function TrialPage() {
  return <main className="bg-gray-50 min-h-screen pb-20" data-id="element-633">
      <TrialHero data-id="element-634" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10 relative z-10" data-id="element-635">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-636">
          {/* Left Column: Details */}
          <div className="lg:col-span-7 order-2 lg:order-1" data-id="element-637">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 h-full" data-id="element-638">
              <TrialDetails data-id="element-639" />
            </div>
          </div>

          {/* Right Column: Form */}
          <div className="lg:col-span-5 order-1 lg:order-2" data-id="element-640">
            <div className="sticky top-24" data-id="element-641">
              <TrialForm data-id="element-642" />
            </div>
          </div>
        </div>
      </div>
    </main>;
}